// extracted by mini-css-extract-plugin
export default {"pageContainer":"ProjectsPage_pageContainer__qGs-B"};